import { useEffect } from 'preact/hooks';
import { path, parseRoute } from './router';
import { bootstrap, state, slug as slugSig, lastError, loading, conflictPending, resolveConflictKeepServer } from './store/store';
import { setOfflineMode } from './store/api';
import { PlanPage } from './pages/PlanPage';
import { RecipesPage } from './pages/RecipesPage';
import { RecipeDetailPage } from './pages/RecipeDetailPage';
import { ShoppingPage } from './pages/ShoppingPage';
import { SettingsPage } from './pages/SettingsPage';
import { ConflictBanner } from './components/ConflictBanner';
import type { MealType } from './types';

// Local dev runs against localStorage (no backend); deployed builds talk to /api/state.
setOfflineMode(import.meta.env.DEV);

export function App() {
  const { slug, route } = parseRoute(path.value);

  useEffect(() => {
    if (slug && slugSig.value !== slug) {
      void bootstrap(slug);
    }
  }, [slug]);

  const banner = (
    <ConflictBanner
      visible={conflictPending.value !== null}
      onReload={() => void resolveConflictKeepServer()}
    />
  );

  if (!slug) {
    return (
      <>{banner}<div style={{ padding: 24 }}>
        <h1>MealPlan</h1>
        <p>Open at <code>/h/&lt;family-slug&gt;/</code> to use the app.</p>
      </div></>
    );
  }
  if (loading.value || !state.value) {
    return <>{banner}<div style={{ padding: 24 }}>Loading…</div></>;
  }
  if (lastError.value) {
    return <>{banner}<div style={{ padding: 24 }}>Error: {lastError.value}</div></>;
  }

  if (route.name === 'plan') return <>{banner}<PlanPage weekId={route.weekId} /></>;
  if (route.name === 'recipes') {
    return <>{banner}<RecipesPage slot={route.slot ? { date: route.slot.date, meal_type: route.slot.meal_type as MealType } : undefined} /></>;
  }
  if (route.name === 'recipe-detail') return <>{banner}<RecipeDetailPage id={route.id} /></>;
  if (route.name === 'shopping') return <>{banner}<ShoppingPage weekId={route.weekId} /></>;
  if (route.name === 'settings') return <>{banner}<SettingsPage /></>;
  return <>{banner}<div style={{ padding: 24 }}>Route {route.name} not yet implemented.</div></>;
}
